import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { AccountInventoryResultState } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';
import { AppContext } from '../../context';
const MessageKey = AppContext.MessageKey;
import { translator } from '../../translator';

export const actions: ActionTree<AccountInventoryResultState, RootState> = {
    /**
     * アカウント棚卸結果一覧検索
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @returns {Promise<void>}
     */
    async search({ dispatch, commit }, { searchItems = {}, pageNumber, perPage, sort, inventorySettingId } = {}) {
        const payload = {
            word: searchItems.word,
            start_created_date: searchItems.start_created_date == '' ? undefined : searchItems.start_created_date,
            end_created_date: searchItems.end_created_date == '' ? undefined : searchItems.end_created_date,
            start_updated_date: searchItems.start_updated_date == '' ? undefined : searchItems.start_updated_date,
            end_updated_date: searchItems.end_updated_date == '' ? undefined : searchItems.end_updated_date,
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
            inventory_setting_id: inventorySettingId,
        };
        try {
            commit(types.SEARCH_START);
            const resData = await dispatch(
                'auth/api',
                { method: 'get', url: ApiUrl.AccountInventoryResult.SEARCH, params: payload },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SEARCH_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SEARCH_FAILURE, resData.errors[0]);
        }
    },

    /**
     * アカウント棚卸結果詳細基本情報取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {number} id アカウント棚卸結果ID
     * @returns {Promise<void>}
     */
    async show({ dispatch, commit }, id: number) {
        try {
            commit(types.SHOW_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.AccountInventoryResult.SHOW.replace(':id', id.toString()),
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SHOW_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SHOW_FAILURE, resData.errors[0]);
        }
    },

    /**
     * アカウント棚卸結果詳細検索 ノードグループ
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {number} id アカウント棚卸結果ID
     * @param {any} word 検索キーワード
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @returns {Promise<void>}
     */
    async nodeItems({ dispatch, commit }, { id, searchItems = {}, pageNumber, perPage, sort } = {}) {
        const payload = {
            word: searchItems.word,
            start_loggedin_date: searchItems.start_loggedin_date == '' ? undefined : searchItems.start_loggedin_date,
            end_loggedin_date: searchItems.end_loggedin_date == '' ? undefined : searchItems.end_loggedin_date,
            start_password_changed_date:
                searchItems.start_password_changed_date == '' ? undefined : searchItems.start_password_changed_date,
            end_password_changed_date:
                searchItems.end_password_changed_date == '' ? undefined : searchItems.end_password_changed_date,
            archive_node_types: searchItems.archive_node_types,
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        try {
            commit(types.NODE_ITEMS_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.AccountInventoryResult.NODE_ITEMS.replace(':id', id.toString()),
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.NODE_ITEMS_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.NODE_ITEMS_FAILURE, resData.errors[0]);
        }
    },

    /**
     * アカウント棚卸結果詳細検索 ノードドメイン
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {number} id アカウント棚卸結果ID
     * @param {any} word 検索キーワード
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @returns {Promise<void>}
     */
    async domainItems({ dispatch, commit }, { id, searchItems = {}, pageNumber, perPage, sort } = {}) {
        const payload = {
            word: searchItems.word,
            start_loggedin_date: searchItems.start_loggedin_date == '' ? undefined : searchItems.start_loggedin_date,
            end_loggedin_date: searchItems.end_loggedin_date == '' ? undefined : searchItems.end_loggedin_date,
            start_password_changed_date:
                searchItems.start_password_changed_date == '' ? undefined : searchItems.start_password_changed_date,
            end_password_changed_date:
                searchItems.end_password_changed_date == '' ? undefined : searchItems.end_password_changed_date,
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        try {
            commit(types.DOMAIN_ITEMS_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.AccountInventoryResult.DOMAIN_ITEMS.replace(':id', id.toString()),
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.DOMAIN_ITEMS_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.DOMAIN_ITEMS_FAILURE, resData.errors[0]);
        }
    },

    /**
     * アカウント棚卸結果差分取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @param {any} id1 取得対象アカウント棚卸結果ID1
     * @param {any} id2 取得対象アカウント棚卸結果ID2
     * @returns {Promise<void>}
     */
    async diff({ dispatch, commit, rootState }, { id1, id2 } = {}) {
        const payload = {
            id1: id1,
            id2: id2,
        };
        try {
            commit(types.DIFF_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'post',
                    url: ApiUrl.AccountInventoryResult.DIFF,
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.DIFF_SUCCESS);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const message = translator(i18n, MessageKey.AccountInventoryResult.DIFF);
                dispatch('toastMessage', message, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.DIFF_FAILURE, params);
        }
    },

    /**
     * アカウント棚卸再実行
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @returns {Promise<void>}
     */
    async retry({ dispatch, commit, rootState }, id: number) {
        try {
            commit(types.RETRY_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'post',
                    url: ApiUrl.AccountInventoryResult.RETRY.replace(':id', id.toString()),
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.RETRY_SUCCESS);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const message = translator(i18n, MessageKey.AccountInventoryResult.RETRY);
                dispatch('toastMessage', message, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.RETRY_FAILURE, params);
        }
    },

    /**
     * CSV出力
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @returns {Promise<void>}
     */
    async csv({ dispatch, commit, rootState }, id: number) {
        try {
            commit(types.CSV_OUTPUT_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'post',
                    url: ApiUrl.AccountInventoryResult.CSV_OUTPUT.replace(':id', id.toString()),
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.CSV_OUTPUT_SUCCESS);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const message = translator(i18n, MessageKey.Csv.OUTPUT);
                dispatch('toastMessage', message, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.CSV_OUTPUT_FAILURE, params);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
